export const DEVICES = {
    CAMERA: 'videoinput',
    MICROPHONE: 'audioinput',
    SPEAKER: 'audiooutput',
  };